<button [id]="idVal" type="button" (click)="onClick.emit($event)" class="btn" [ngClass]="classes">
  {{ label }}
  <img src="assets/images/sort_321.png" alt="Logo" width="36" height="22" >
</button>
